<template>
  <smart-banner
    bg-color="#02295C"
    direction="center"
    :has-kicker="false"
    title-color="#FFFFFF"
    title-size="h2"
    title-weight="400"
    title-align="center"
    text-color="#EDF2F5"
    text-size="xs"
    text-weight="400"
    text-align="center"
    :has-button="true"
    :has-image="false"
    :center-items="true"
    :reduce-width="true"
    :has-video="false"
  >
    <template #breadcrumb>
      <slot name="quaternary-breadcrumb" />
    </template>
    <template #title>
      <slot name="quaternary-title" />
    </template>
    <template #text>
      <slot name="quaternary-text" />
    </template>
    <template #button>
      <slot name="quaternary-buttons" />
    </template>
  </smart-banner>
</template>

<script>
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-quaternary',
  components: {
    SmartBanner,
  }
}
</script>
